import { render, staticRenderFns } from "./AlarmCenter.vue?vue&type=template&id=b0b42332&scoped=true"
import script from "./AlarmCenter.vue?vue&type=script&lang=js"
export * from "./AlarmCenter.vue?vue&type=script&lang=js"
import style0 from "./AlarmCenter.vue?vue&type=style&index=0&id=b0b42332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b42332",
  null
  
)

export default component.exports